import { render, staticRenderFns } from "./TableSalesReportItem.vue?vue&type=template&id=45a617fe&scoped=true"
import script from "./TableSalesReportItem.vue?vue&type=script&lang=js"
export * from "./TableSalesReportItem.vue?vue&type=script&lang=js"
import style0 from "./TableSalesReportItem.vue?vue&type=style&index=0&id=45a617fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a617fe",
  null
  
)

export default component.exports